import React from 'react';
import AdminSidebar from './AdminLayout/Sidebar/SideBar';
import {Link, Route, Switch} from "react-router-dom";
import "./AdminRoot.css";
import "../../Common/AdminResponsive.css";
import "../../Common/ModalsResponsive.css";
import '../../Common/Common.css';
import UserCreate from "../UserCreate/UserCreate";
import UserUpdate from "../UserUpdate/UserUpdate";
import Inquiry from "../Inquiry/Inquiry";
import InquiryReply from "../InquiryReply/InquiryReply";
import AllCustomers from "../AllCustomers/AllCustomers";
import UserInformation from "../Customer/UserInformation";
import InquiriesPerUser from "../InquiriesPerUser/InquiriesPerUser";
import ViewSingleCustomerOrder from "../Order/ViewSingleCustomerOrder/ViewSingleCustomerOrder";
import ViewSingleCustomerSales from "../Sales/ViewSingleCustomerSale/ViewSingleCustomerSales";
import CurrencyConfiguration from "../SystemConfiguration/CurrencyConfiguration/CurrencyConfiguration";
import AllSales from "../Sales/ViewAllSales/ViewAllSales";
import ViewAllOrders from "../Order/ViewAllOrders/ViewAllOrders";
import Logout from "../../../Logout";
import AllAdminUsers from "../AllAdminUsers/AllAdminUsers";
import AdminInformation from "../AdminInformation/AdminInformation";
import AdminChat from "../AdminChat/AdminChat";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../configuration";
import LastOrderCaller from "../AllCustomers/AllCustomersRow/LastOrderCaller";
import CustomerOrderTable from "../Customer/CustomerOrderTable/CustomerOrderTable";
import AllOrdersCaller from "../AllCustomers/AllCustomersRow/AllOrdersCaller";
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../../Site/QuotationForm/InitialQuotationState";
import UserProfile from "../../Site/UserProfile/UserProfile";
import PasswordChange from "../../Site/SiteRoot/SiteRoot";
import NewArticle from "../Articles/NewArticle/NewArticle";
import ViewAllArticles from "../Articles/ViewAllArticles/ViewAllArticles";
import ArticleEdit from "../Articles/ArticleEdit/ArticleEdit";
import ProductionCompletionList from "../ProductionCompletionList/ProductionCompletionList";
import axios from "axios";
import ViewSingleItem from "../ProductionCompletionList/ViewSingleItem";
import NewQualityComplaint from "../NewQualityComplaint/NewQualityComplaint";
import CancelledOrders from "../Sales/CancelledOrder/CancelledOrders";
import $ from "jquery";

class AdminComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            langValue: InitialQuotationState.lang,
            checked: false,
            chatMap: Map,
            chatUserCount: 0,
            userIds: [],
            userToAdminMap: Map,
            user: null,
            showAdminContent: true
        };
        this.handleChange = this.handleChange.bind(this);
        this.changeChatMapCount = this.changeChatMapCount.bind(this);
        this.getAllPendingChats = this.getAllPendingChats.bind(this);
        this.getUserDetails = this.getUserDetails.bind(this);
        this.toggleClicked = this.toggleClicked.bind(this);
    }

    toggleClicked() {

        // $('.admin-content').removeClass('content-block-absolute')
        // $('.sidebar-content').removeClass('sideBar-block-absolute')


        this.setState({
            showAdminContent: !this.state.showAdminContent
        }, () => {
            console.log("")
            if (this.state.showAdminContent) {
                document.getElementById("admin-content").style.display = "block";
            } else {
                document.getElementById("admin-content").style.display = "none";
            }
        });


    };

    handleChange(checked) {
        // console.log("switch triggering===>", checked);
        this.setState({checked});
        this.props.onLanguageChange(checked);
    }

    componentDidMount() {
        console.log("link to admin");
        if (InitialQuotationState.lang === "ja") {
            this.setState({
                checked: true
            })
        }
        this.getAllPendingChats();
        this.getUserDetails();

        setTimeout(() => {

            var coll = document.getElementsByClassName("collapsible");
            var i;

            for (i = 0; i < coll.length; i++) {
                coll[i].addEventListener("click", function () {

                    this.classList.toggle("active");
                    var content = document.getElementsByClassName("sidebar-content")[0];
                    content.style.display = "block"
                    if (content.style.position === "inherit") {
                        content.style.position = "absolute";

                    } else {
                        content.style.position = "inherit";
                    }
                });
            }
        }, 100)

    }

    isInChatWithAnotherAdmin = (chatUserId) => {
        if (this.state.userToAdminMap[chatUserId] === this.props.userId || this.state.userToAdminMap[chatUserId] === "ADMIN-ANY") {
            return false;
        }
        return true;
    }

    getUserDetails = () => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId, axiosConfig)
            .then((res) => {

                this.setState({
                    userName: res.data.name,
                    user: res.data
                });

                // console.log("USERRRRRRR DUO =====> ", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                console.log("Token invalid");
                localStorage.clear();
                window.location.replace(BASE_URL + "login");
            });
    };

    getAllPendingChats = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/admin/pending', axiosConfig)
            .then((res) => {
                console.log("CHAT-DATA-ADMIN-ROOT===========>>>>..........", res.data);
                console.log("CHAT-DATA-ADMIN-ROOT=====userMessagesMap======>>>>..........", res.data.userMessagesMap);

                this.setState({
                    userToAdminMap: res.data.userToAdminMap
                });
                var chatCount = 0;
                var notRespondCount = 0;
                Object.keys(res.data.userMessagesMap).map(userId => {
                    this.state.userIds.push(userId);
                });
                Object.keys(res.data.userMessagesMap).map(chatUserId => {

                    // console.log("hello----------this.state.chatMap[chatUserId]----------------- ", res.data.userMessagesMap[chatUserId])
                    // console.log("hello----------logged user id----------------- ", this.props.userId);
                    var isAdminChat = true;
                    for (var i = 0; i < res.data.userMessagesMap[chatUserId].length; i++) {
                        if (res.data.userMessagesMap[chatUserId][i].inChatWithAdmin) {
                            isAdminChat = false;

                            if (this.props.userId === res.data.userMessagesMap[chatUserId][i].sender || this.props.userId === res.data.userMessagesMap[chatUserId][i].receiver) {
                                isAdminChat = true;
                            }
                        }

                    }

                    var sender = res.data.userMessagesMap[chatUserId][res.data.userMessagesMap[chatUserId].length - 1].sender;
                    var receiver = res.data.userMessagesMap[chatUserId][res.data.userMessagesMap[chatUserId].length - 1].receiver;
                    if (this.state.userIds.includes(sender) && !this.isInChatWithAnotherAdmin(sender)) {
                        notRespondCount++;
                    }

                    if (isAdminChat) {
                        chatCount++;
                    }
                });

                this.setState({
                    chatMap: res.data.userMessagesMap,
                    // chatUserCount : res.data.onlineUsers
                    // chatUserCount: chatCount
                    chatUserCount: notRespondCount
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    }

    changeChatMapCount = (count) => {
        this.setState({
            chatMapCount: count
        })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log("link to admin" + this.props.match.url);
        if (prevProps.userData !== this.props.userData) {
            // this.props.keycloak.login({redirectUri: BASE_URL + "admin"});
        }
    }

    render() {
            return (
                <div className="container-fluid no-padding">
                    <div className="row row-margin-right-responsive">
                        <nav className=" nav-style">
                            <div className="container-fluid">
                                <div className="" id="bs-example-navbar-collapse-1">

                                    <ul className="nav navbar-nav">
                                        <li>
                                            <div className="admin-nav-item">
                                                <span className="header-link">
                                                    {/*<button className="collapsible"></button>*/}

                                                    <span className="toggle-background-color ">
                                                    <button className="navbar-toggle collapsible collapsible1"
                                                            onClick={this.toggleClicked}>
                                                    <span className="sr-only">Toggle navigation</span>
                                                    <span className="icon-bar icon-bar2"></span>
                                                    <span className="icon-bar icon-bar2"></span>
                                                    <span className="icon-bar icon-bar2"></span>
                                                </button>
                                                    </span>
                                                </span>
                                                <span className="brand-name">KITCUT</span>
                                                &nbsp;
                                                <span className="header-link">
                                                    <Link to="/" className="header-link-text-color">
                                                        <FormattedMessage id="app.admin.kitcut-site"
                                                                          defaultMessage="KITCUT SITE"
                                                                          description=""/>
                                                    </Link>
                                                </span>
                                                <span className="header-link">
                                                    <Link to="/profile">
                                                            {InitialQuotationState.naviUserName}
                                                    </Link>
                                                </span>
                                                <span className="header-link">
                                                     <Link to="/logout">
                                                            <FormattedMessage id="app.admin.logout"
                                                                              defaultMessage="Logout"
                                                                              description=""/>
                                                        </Link>
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right web-navbar">
                                        <li>
                                            <div className="admin-nav-item">
                                                <Link to="/quotation/pcb" className="header-link-text-color">
                                                    <FormattedMessage id="app.admin.kitcut-site"
                                                                      defaultMessage="KITCUT SITE"
                                                                      description=""/>
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="admin-nav-item">
                                                <div className="admin-dropdown">
                                                    <span
                                                        className="dropdown-button">{InitialQuotationState.naviUserName}</span>
                                                    <div className="admin-dropdown-content">

                                                        <Link to="/profile">
                                                            <p className="link-text-style">ユーザー情報設定</p>
                                                        </Link>

                                                        <Link to="/logout">
                                                            <p className="link-text-style">
                                                                <FormattedMessage id="app.admin.logout"
                                                                                  defaultMessage="Logout"
                                                                                  description=""/>
                                                            </p>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                    <div className="row admin-main-div" id="admin-all-div-color">
                        <div className="col-md-2 sidebar-content">
                            <AdminSidebar onlineChatUsers={this.state.chatUserCount}/>
                        </div>

                        <div className="col-md-10 admin-content" id="admin-content">
                            <Switch>
                                <Route path="/admin/users/create"
                                       render={(props) =>
                                           <UserCreate {...props}
                                                       userId={this.props.userId}
                                                       userData={this.props.userData}
                                           />
                                       }/>
                                <Route path="/admin/users/update/:id" component={UserUpdate}/>
                                <Route path="/admin/customers/view/:id" component={UserInformation}/>
                                <Route path="/admin/customers/viewOrders/:id"
                                       component={CustomerOrderTable}/>
                                <Route path="/admin/inquiries/viewAll" component={Inquiry}/>
                                <Route path="/admin/customers/all" component={AllCustomers}/>


                                {/*///////////////////////////////////////////////////////////////////////////////////////////////////////*/}

                                <Route path="/admin/inquiries/perUser/:id"
                                       component={InquiriesPerUser}
                                    // render={() => (<div>List of items</div>)}
                                />
                                {/*///////////////////////////////////////////////////////////////////////////////////////////////////////*/}


                                <Route path="/admin/orders/view/:id"
                                       component={ViewSingleCustomerOrder}/>
                                <Route path="/admin/items/view/:id"
                                       component={ViewSingleItem}/>
                                <Route path="/admin/sales/view/:id"
                                       component={ViewSingleCustomerSales}/>
                                <Route path="/admin/sales/view" component={AllSales}/>
                                <Route path="/admin/sales/cancelled" component={CancelledOrders}/>
                                <Route path="/admin/orders/all"
                                       render={(props) =>
                                           <ViewAllOrders {...props}
                                                          userId={this.props.userId}
                                           />
                                       }/>
                                <Route path="/admin/users/all" render={(props) =>
                                    <AllAdminUsers {...props}
                                                   userId={this.props.userId}
                                    />
                                }/>
                                <Route path="/admin/users/view/:id" component={AdminInformation}/>
                                <Route path="/admin/chat" render={(props) =>
                                    <AdminChat {...props}
                                               offlineUserId={this.props.offlineUserId}
                                               userId={this.props.userId}
                                               getAllPendingChats={this.getAllPendingChats}
                                    />
                                }/>
                                <Route path="/admin/customers/last/:userId"
                                       component={LastOrderCaller}/>
                                <Route path="/admin/customers/allOrders/:userId"
                                       component={AllOrdersCaller}/>
                                <Route exact path="/admin/inquiries/reply/:id"
                                       render={(props) =>
                                           <InquiryReply {...props}
                                                         userData={this.props.userData}
                                                         authenticate={this.props.authenticate}
                                                         authenticated={this.props.authenticated}
                                                         userId={this.props.userId}
                                           />
                                       }
                                />
                                <Route exact path="/admin/currency/configuration"
                                       render={(props) =>
                                           <CurrencyConfiguration {...props}
                                                                  userData={this.props.userData}
                                                                  authenticate={this.props.authenticate}
                                                                  authenticated={this.props.authenticated}
                                                                  userId={this.props.userId}
                                           />
                                       }
                                />
                                <Route path="/admin/article/new"
                                       render={(props) =>
                                           <NewArticle {...props}
                                                       userData={this.props.userData}
                                                       authenticate={this.props.authenticate}
                                                       authenticated={this.props.authenticated}
                                                       userId={this.props.userId}
                                           />
                                       }
                                />
                                <Route path="/admin/article/edit/:articleId"
                                       render={(props) =>
                                           <ArticleEdit {...props}
                                                        userData={this.props.userData}
                                                        authenticate={this.props.authenticate}
                                                        authenticated={this.props.authenticated}
                                                        userId={this.props.userId}
                                           />
                                       }
                                />

                                <Route path="/admin/article/all"
                                       render={(props) =>
                                           <ViewAllArticles {...props}
                                                            userData={this.props.userData}
                                                            authenticate={this.props.authenticate}
                                                            authenticated={this.props.authenticated}
                                                            userId={this.props.userId}
                                           />
                                       }
                                />
                                <Route path="/admin/production"
                                       render={(props) =>
                                           <ProductionCompletionList {...props}
                                                                     userData={this.props.userData}
                                                                     authenticate={this.props.authenticate}
                                                                     authenticated={this.props.authenticated}
                                                                     userId={this.props.userId}
                                           />
                                       }
                                />
                                <Route path="/admin/quality-complaint"
                                       component={NewQualityComplaint}/>

                                <Route path='/logout'
                                       render={(props) =>
                                           <Logout {...props}
                                                   userData={this.props.userData}
                                           />
                                       }
                                />
                                <Route path='/profile'
                                       render={(props) =>
                                           <UserProfile {...props}
                                                        authenticate={this.props.authenticate}
                                                        userData={this.props.userData}
                                                        authenticated={this.props.authenticated}
                                                        userId={this.props.userId}
                                                        isAdmin={this.props.isAdmin}/>
                                       }/>
                                <Route path='/changePassword'
                                       render={(props) =>
                                           <PasswordChange {...props}
                                                           userData={this.props.userData}
                                                           userId={this.state.userId}
                                           />
                                       }
                                />


                                <Route path={`/admin/`}
                                       render={(props) =>
                                           <InquiriesPerUser {...props}
                                               // userId={this.state.userId}
                                                             userId={InitialQuotationState.selectedUserId}
                                           />
                                       }

                                    // component={InquiriesPerUser}
                                />


                                <Route path={`/admin/`} component={Inquiry}/>
                            </Switch>


                        </div>
                    </div>
                </div>
            );
    }
}

export default AdminComponent;



// WEBPACK FOOTER //
// ./src/components/Admin/AdminRoot/AdminRoot.js